// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import {fetch} from 'wix-fetch';
$w.onReady(function () {
	//TODO: write your page related code here...

});

// export function button1_click(event) {

// 	// fetch("https://api.whatsapp.com/send?phone=972586344040&text='http://kcm.fm/'")
// 	//Add your code for this event here: 
// }